import React, { useState } from "react";
import { Building2 } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import "./LoginPage.css";

export default function LoginPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({ email: "", password: "" });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (form.email && form.password) {
      alert(`Welcome back, ${form.email.split("@")[0]}!`);
      navigate("/employee-dashboard"); // Redirect to employee dashboard
    } else {
      alert("Please fill in all fields.");
    }
  };

  return (
    <div className="login-root">
      <div className="login-card">
        <h2 className="login-title">Employee Login</h2>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-field">
            <label className="login-label">Email</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="login-input"
              required
            />
          </div>

          <div className="login-field">
            <label className="login-label">Password</label>
            <input
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="login-input"
              required
            />
          </div>

          <button type="submit" className="login-button">Login</button>
        </form>

        <div className="login-links">
          <Link to="/signup" className="signup-link">Don't have an account? Sign up</Link>
          <Link to="/" className="back-link"><Building2 className="back-icon" /> Back to Home</Link>
        </div>
      </div>
    </div>
  );
}
